import get from 'lodash/get.js';

import BaseInterceptor from '@/router/interceptors/BaseInterceptor.js';
import ImpersonationExpiryMonitor from '@/services/ImpersonationExpiryMonitor.js';

class ImpersonationExpiredInterceptor extends BaseInterceptor {
    handle(status, error) {
        if (status !== 409) {
            return false;
        }

        if (!get(error, 'response.data.impersonation_expired')) {
            return false;
        }

        ImpersonationExpiryMonitor.handleExpiredResponse(get(error, 'response.data', {}));

        return true;
    }
}

export default ImpersonationExpiredInterceptor;
